import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["code", "button"]
  static values = { url: String }

  async copy() {
    const text = this.urlValue || this.codeTarget?.textContent?.trim()
    if (!text) return

    try {
      await navigator.clipboard.writeText(text)
      const originalText = this.buttonTarget.textContent
      this.buttonTarget.textContent = "¡Copiado!"
      setTimeout(() => {
        this.buttonTarget.textContent = originalText
      }, 2000)
    } catch (err) {
      console.error("Failed to copy:", err)
    }
  }
}
